import { useState, useRef, useEffect } from "react";
import { Sparkles, X, Send, Loader2, Bot } from "lucide-react";
import api from "../lib/api";

const SUGGESTIONS = [
  "Best areas to invest in Noida?",
  "How much EMI for a ₹80L home loan?",
  "What should I check before buying a plot?",
];

export function AssistantWidget() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "bot", text: "Hi! I'm PBS Assistant 🤖 Ask me anything about buying, renting, plots, loans or investing in Indian real estate." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [sid, setSid] = useState("");
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, open]);

  const send = async (text) => {
    const msg = (text || input).trim();
    if (!msg || loading) return;
    setInput("");
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setLoading(true);
    try {
      const res = await api.assistant(msg, sid);
      setSid(res.session_id);
      setMessages((m) => [...m, { role: "bot", text: res.reply }]);
    } catch {
      setMessages((m) => [...m, { role: "bot", text: "Sorry, I'm having trouble right now. Please try again in a moment." }]);
    } finally { setLoading(false); }
  };

  return (
    <>
      <button
        data-testid="assistant-toggle"
        onClick={() => setOpen((o) => !o)}
        className="fixed z-[55] bottom-20 lg:bottom-6 right-4 lg:right-6 w-14 h-14 rounded-full pbs-gradient text-white shadow-[0_8px_30px_rgba(35,107,69,0.4)] flex items-center justify-center hover:scale-105 transition-transform"
        aria-label="AI Assistant"
      >
        {open ? <X size={24} /> : <Sparkles size={24} />}
      </button>

      {open && (
        <div data-testid="assistant-panel" className="fixed z-[55] bottom-36 lg:bottom-24 right-4 lg:right-6 w-[calc(100vw-2rem)] sm:w-96 h-[70vh] sm:h-[520px] bg-white rounded-2xl shadow-2xl border border-pbs-line flex flex-col overflow-hidden animate-fade-up">
          <div className="pbs-gradient text-white px-4 py-3 flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-lg bg-white/15 flex items-center justify-center"><Bot size={18} /></div>
            <div>
              <p className="font-bold text-sm leading-tight">PBS Assistant</p>
              <p className="text-[11px] text-white/75">Powered by Gemini AI</p>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-3.5 space-y-3 bg-pbs-bg">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-3.5 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap ${m.role === "user" ? "bg-pbs-purple text-white rounded-br-sm" : "bg-white border border-pbs-line text-pbs-dark rounded-bl-sm"}`}>
                  {m.text}
                </div>
              </div>
            ))}
            {loading && <div className="flex justify-start"><div className="bg-white border border-pbs-line rounded-2xl px-4 py-3"><Loader2 size={16} className="animate-spin text-pbs-purple" /></div></div>}
            {messages.length === 1 && (
              <div className="flex flex-wrap gap-2 pt-1">
                {SUGGESTIONS.map((s) => <button key={s} onClick={() => send(s)} className="text-xs bg-white border border-pbs-line rounded-full px-3 py-1.5 text-pbs-purple hover:border-pbs-purple">{s}</button>)}
              </div>
            )}
            <div ref={endRef} />
          </div>

          <form onSubmit={(e) => { e.preventDefault(); send(); }} className="p-3 border-t border-pbs-line flex items-center gap-2">
            <input data-testid="assistant-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask about properties, loans, areas…"
              className="flex-1 bg-pbs-bg border border-pbs-line rounded-lg px-3 py-2.5 text-sm outline-none focus:border-pbs-purple" />
            <button type="submit" data-testid="assistant-send" disabled={loading} className="w-10 h-10 rounded-lg pbs-gradient text-white flex items-center justify-center shrink-0 disabled:opacity-50"><Send size={16} /></button>
          </form>
        </div>
      )}
    </>
  );
}

export default AssistantWidget;
